import moment from "moment";
import { displayDateFormat } from "../../../utils/helpers";

export const l1Columns = ({ tableData, extraColumns = [], userLabel = "" }) => [
  ...extraColumns,
  {
    Header: "Submit On",
    accessor: "submittedOn",
    Cell: (props) => {
      if (!props?.row?.original?.submittedOn) {
        return "-";
      }
      return (
        <div>
          {moment(
            props?.row?.original?.submittedOn).format(displayDateFormat)}
          {/* {props?.row?.original?.submittedOn} */}
        </div>
      );
    },
  },
  {
    Header: "Requested Amount(₹)",
    accessor: "amount",
    Cell: (rowData) => {
      const value = rowData?.row?.original?.amount;
      let amount;
      if(typeof value == "string"){
        amount = Number(value).toFixed(2);
      } else {
        amount = value
      }
      return amount ? Number(amount).toFixed(2) : "-";
    },
  },
  {
    Header: "Approved Amount(₹)",
    accessor: "approvedAmount",
    Cell: (rowData) => {
      const row = rowData?.row?.original || {};
      const ul = String(userLabel ?? "")
        .trim()
        .toLowerCase();
      let value;
      if (ul === "l1") {
        value = row.l1AmountApproved ?? row.l1_amount_approved ?? row.approvedAmount;
      } else if (ul === "l2") {
        value = row.l2AmountApproved ?? row.l2_amount_approved ?? row.approvedAmount;
      } else if (ul === "finance" || ul === "l3" || ul === "accounts") {
        value = row.l3AmountApproved ?? row.l3_amount_approved ?? row.approvedAmount;
      } else {
        value = row.approvedAmount ?? row.l1AmountApproved ?? row.l1_amount_approved;
      }
      // #region agent log
      fetch("http://127.0.0.1:7725/ingest/1e0759ae-3f2b-41c8-ba49-6374b98795f6", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Debug-Session-Id": "2ecc22",
        },
        body: JSON.stringify({
          sessionId: "2ecc22",
          runId: "approved-tab-v1",
          hypothesisId: "H1-H4",
          location: "ApprovedVouchers.js:ApprovedAmountCell",
          message: "Approved tab amount source selection",
          data: {
            userLabel: String(userLabel || ""),
            voucherId: row?.id ?? null,
            requestedAmount: row?.amount ?? null,
            apiApprovedAmount: row?.approvedAmount ?? null,
            l1AmountApproved: row?.l1AmountApproved ?? row?.l1_amount_approved ?? null,
            l2AmountApproved: row?.l2AmountApproved ?? row?.l2_amount_approved ?? null,
            l3AmountApproved: row?.l3AmountApproved ?? row?.l3_amount_approved ?? null,
            pickedValue: value ?? null,
          },
          timestamp: Date.now(),
        }),
      }).catch(() => {});
      // #endregion
      let amount;
      if (typeof value == "string") {
        amount = Number(value).toFixed(2);
      } else {
        amount = value;
      }
      return amount ? Number(amount).toFixed(2) : "-";
    },
  },

  {
    Header: "Status",
    accessor: "Approved",
    Cell: () => {
      return <div className={"text-[var(--successGreen)]"}>Approved</div>;
    },
  },
  // {
  //   Header: "Approved",
  //   accessor: "approvedAmount",
  //   Cell: (props) => {
  //     const value = props?.row?.original?.approvedAmount;
  //     if (!value) {
  //       return "-";
  //     }
  //     return <div className={"text-[var(--successGreen)]"}>{value}</div>;
  //   },
  // },
];
